module.exports = __webpack_public_path__ + "static/media/icon_search_blue_dark.03015606.svg";